module.exports = __webpack_public_path__ + "img/expand.bdfd6cee.svg";